import {
  buildAdminListQuery,
  type TAdminListParams,
} from '@/core/lib/table-query'

export const teamTagEndpoints = {
  list: (params: TAdminListParams) =>
    `/admin/team-tags?${buildAdminListQuery(params)}`,
  options: '/admin/team-tags/options',
  create: '/admin/team-tags',
  detail: (id: string) => `/admin/team-tags/${id}`,
  update: (id: string) => `/admin/team-tags/${id}`,
  delete: (id: string) => `/admin/team-tags/${id}`,
  teamTags: (teamId: string) => `/admin/teams/${teamId}/tags`,
}

export const TEAM_TAG_QUERY_KEYS = {
  list: (params: TAdminListParams) => ['team-tags', 'list', params] as const,
  options: ['team-tags', 'options'] as const,
  teamTags: (teamId: string) => ['team-tags', 'team', teamId] as const,
}

export const teamTagSuccessMessages = {
  create: 'Takım etiketi oluşturuldu!',
  update: 'Takım etiketi güncellendi!',
  delete: 'Takım etiketi silindi!',
  assign: 'Takım etiketleri güncellendi!',
}
